module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "dedication",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("For Laurence, who was my inspiration."), _c('br'), _vm._v("E."), _c('span', {
    attrs: {
      "xml:lang": "ar-SA"
    }
  }), _vm._v("C."), _c('br'), _vm._v("In memory of Nana Pat, who really did make our childhood magical."), _c('br'), _vm._v("K."), _c('span', {
    attrs: {
      "xml:lang": "ar-SA"
    }
  }), _vm._v("C.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090b1cac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled128.vue
// module id = 60
// module chunks = 0